import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table, CommonErrors } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { eswiEnvs, eswiUtils } from "@/tra/tancis/eswi/comn";
import { HS_VRFN_PPUP } from "./HS_VRFN_PPUP";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_HS_APP,
    SG_APP_HS_CODE_LIST_R,
    SG_HS_APRV_HIST_LIST,
    SF_SCHEMA_HS_APP_ASIN,
    SF_HS_VRFN_ASIN_NEW,
} from "@/tra/tancis/eswi/hs/vrfn/service/EswiHsVrfnService";
import { UsrLstbyRole } from "./UsrLstbyRole";

export const ESWI0101004S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const pgeUid = "UI-ESWO-0107-003S"; // Page Unique identifier !== 화면 고유 식별자 ==!
    const { pgeUid, menuId } = usePage({
        auth: ["auth_eswi0007"],
    });
    const pgeTitle = "Registering Control HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { hsAppUuid } = useParams();

    const refOrginData = useRef({});

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "orgCd" },
            { area: "comnCd", comnCd: "ESW0009" },
            { area: "comnCd", comnCd: "ESW0032" },
            { area: "comnCd", comnCd: "ESW0030" },
            { area: "comnCd", comnCd: "ESW0029" },
            { area: "comnCd", comnCd: "ESW0009" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        hsAppForm: useForm({
            defaultSchema: SF_SCHEMA_HS_APP_ASIN,
            defaultValues: {},
        }),
        hsvrfnAsinNewInfo: useForm({
            defaultSchema: SF_HS_VRFN_ASIN_NEW,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsVrfnRsptyInfo: useFetch({
            api: (hsAppUuid) => {
                return APIS.getHsVrfnRsptyInfo(hsAppUuid);
            },
            onSuccess: (data) => {
                const info = data.rsptyInfo.content || {};
                form.hsAppForm.setValues({...info});
                form.hsvrfnAsinNewInfo.setValues({
                    asinOfcrId: info.asinOfcrId,
                    newOrgCd: info.orgCd
                });

                refOrginData.current = {...info, excuUserId: info.asinOfcrId };
                form.hsAppForm.setValues(data.rsptyInfo.content);
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.com.00025" });
            },
            showToast: false,
        }),
        createChangeRspty: useFetch({
            api: (data: any) => APIS.createChangeRspty({...data}),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        navigate(URLS.eswi0101003q);
                    },
                    onCancel: () => {
                        navigate(URLS.eswi0101003q);
                    },
                })
            },
            onError: () => {
                modal.openModal({
                    content: "msg.00006",
                });
            }
        })
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            // HS App Information
            fetch.getHsVrfnRsptyInfo.fetch(hsAppUuid);
        },
        onRsptySelected: (data: any) => {
            form.hsvrfnAsinNewInfo.setValue("newAsinOfcrId", data.code);

            console.log("form.appAsinNewInfo ", form.hsvrfnAsinNewInfo.getValues());
        },
        createChangeRspty: form.hsvrfnAsinNewInfo.handleSubmit(() => {
            form.hsvrfnAsinNewInfo.setValue("hsAppUuid", hsAppUuid);
            const data = {...form.hsvrfnAsinNewInfo.getValues()};

            modal.openModal({
                content: "msg.00101",
                onConfirm: () => {
                    fetch.createChangeRspty.fetch(data);
                }
            })
        })
    };

    // useEffect
    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                <Group.Title title={"T_APP_INFO"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgCd} />
                            <Group.Control {...form.hsAppForm.schema.orgChpnId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnTelno} />
                            <Group.Control {...form.hsAppForm.schema.orgChpnEml} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.hsAppNo} />
                            <Group.Control {...form.hsAppForm.schema.prcssStatCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.asnmtOfcrTpCd} />
                            <Group.Control {...form.hsAppForm.schema.asinOfcrId} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Title title={"T_ASIN_INFO"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hsvrfnAsinNewInfo.schema.asinOfcrId}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.hsvrfnAsinNewInfo.schema.newAsinOfcrId}
                                controlSize={5}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        modal.openModal({
                                            content: (
                                                <UsrLstbyRole
                                                    params = {{...refOrginData.current}}
                                                    onSelected={handler.onRsptySelected}
                                                />
                                            ),
                                            size: "md",
                                            draggable: true,
                                        });
                                    },
                                }}
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsvrfnAsinNewInfo.schema.asinMdfyRsn} controlSize={10}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.eswi0101003q);
                        }}
                    ></Button>
                    <Button
                        role="reset"
                        onClick={() => {
                            form.hsvrfnAsinNewInfo.setValue("newAsinOfcrId", "");
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button role="save" onClick={handler.createChangeRspty}></Button>
                    <Button role="cancel" onClick={() => navigate(`${URLS.eswi0101003q}`)}></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
